/* global angular */

var ngModule = angular.module('trends');

ngModule.service('SearchBoxManager', ['$rootScope', function ($rootScope) {
    var _data = { value: '' };

    this.data = function () {
        return _data;
    };

    this.setValue = function (newValue) {
        _data.value = newValue;
    };

    this.getValue = function () {
        return _data.value;
    };

    $rootScope.$on('$stateChangeSuccess', function (evt, toState) {
        if (toState.name !== 'search') {
            _data.value = '';
        }
    });
}]);
